import React from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

const Styled = styled.div`
  background-color: rgba(0, 0, 0, 0.8);
  position: absolute;
  bottom: 0;
  padding: 1rem;
  font-family: "input-mono";
  color: #fff;
  width: 100%;
  box-sizing: border-box;
`;

const DebugLocation = () => {
  const location = useLocation();
  if (process.env?.NODE_ENV !== "development") return null;
  if (!process.env?.REACT_APP_DEBUG_LOCATION) return null;
  return <Styled>{JSON.stringify(location)}</Styled>;
};

export default DebugLocation;
